import React, { FunctionComponent } from 'react';

import { ReactComponent as DetachSvg } from '../../../assets/images/informing/detach.svg';
import { ReactComponent as DevelopSvg } from '../../../assets/images/informing/develop.svg';
import { ReactComponent as EmptySvg } from '../../../assets/images/informing/empty.svg';
import { ReactComponent as ErrorSvg } from '../../../assets/images/informing/error.svg';
import { ReactComponent as SearchSvg } from '../../../assets/images/informing/search.svg';
import { ReactComponent as SuccessfulSvg } from '../../../assets/images/informing/successful.svg';
import { ReactComponent as UnfilledSvg } from '../../../assets/images/informing/unfilled.svg';

export type InformingIconType =
    | 'detach'
    | 'empty'
    | 'search'
    | 'successful'
    | 'unfilled'
    | 'error'
    | 'develop';

const icons: Record<InformingIconType, SvgIcon> = {
    detach: DetachSvg,
    empty: EmptySvg,
    search: SearchSvg,
    successful: SuccessfulSvg,
    unfilled: UnfilledSvg,
    error: ErrorSvg,
    develop: DevelopSvg,
};

type InformingIconProps = {
    icon: InformingIconType;
};
export const InformingIcon: FunctionComponent<InformingIconProps> = (props) => {
    const { icon } = props;

    const Icon = icons[icon];

    return <Icon />;
};
